import { createTheme } from "@mui/material/styles";
import { tokenCss } from "./cssVars";
import { colour, fontFamily } from "./tokens";
const theme = createTheme({
    palette: {
        mode: "light",
        primary: {
            main: colour.accent,
            dark: colour.accentHover,
            light: colour.accentSoft,
            contrastText: colour.onAccent
        },
        error: {
            main: colour.err,
            contrastText: colour.onAccent
        },
        warning: {
            main: colour.warn
        },
        info: {
            main: colour.info
        },
        success: {
            main: colour.ok
        },
        background: {
            default: colour.surface,
            paper: colour.surface
        },
        text: {
            primary: colour.ink,
            secondary: colour.ink2,
            disabled: colour.ink3
        },
        divider: colour.line
    },
    shape: {
        borderRadius: 4
    },
    typography: {
        fontFamily,
        fontSize: 13,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        fontWeightBold: 600,
        button: {
            textTransform: "none"
        }
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: tokenCss
        }
    }
});
export { theme };
